import React, { useState, useContext } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import "./Header.css";
import Darkmode from "../DarkMode/Darkmode";
import { useMediaQuery, useTheme } from "@mui/material";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import { useNavigate } from "react-router-dom";

import { Link } from "react-router-dom";
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
// import lightlogo from "../../Img/light-mode-logo.png";
// import darkLogo from "../../Img/reglogo.png";
import PersonIcon from '@mui/icons-material/Person';
import Collapse from '@mui/material/Collapse';
import DraftsIcon from '@mui/icons-material/Drafts';
import SendIcon from '@mui/icons-material/Send';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import StarBorder from '@mui/icons-material/StarBorder';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import LogoutIcon from '@mui/icons-material/Logout';
import { ThemeContext } from '../DarkMode/ThemeProvider';
import logo from "../../assets/Images/hlogo.png";
const pages = [
    // { name: "Market", url: "/market" },
    { name: "Trade", url: "/trade" },
    { name: "Swap", url: "/swap" },
    { name: "Transaction", url: "/trade" },
    // { name: 'Referral Information', url: '/trade' },
];

const settings = [
    { icon: <PersonIcon />, name: "Profile", url: "/profilenew" },
    // { icon: <PaymentsIcon />, name: "Payment Option", url: "/payment-option" },
    // { icon: <HelpOutlineIcon />, name: "Support", url: "/support" },
    // { icon: <MonetizationOnOutlinedIcon />, name: "Earning", url: "/earning" },
    // {
    //     icon: <AccountCircleIcon />,
    //     name: "Referal Information",
    //     url: "/referralinformation",
    // },
    // {
    //     icon: <MobileFriendlyOutlinedIcon />,
    //     name: "KYC Verification",
    //     url: "/kyc",
    // },
    { icon: <SupportAgentIcon />, name: "Support", url: "/support" },
    { icon: <LogoutIcon />, name: "Logout", url: "/login" },
];
const settings2 = [
    { name: "Deposit", url: "/deposit" },
    { name: "Withdraw", url: "/withdraw" },
    { name: "Staking", url: "/staking" },
    { name: "P2P", url: "/p2p" },
];


const headers = [
    {
        title: 'Trades',
        svg: [<svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.04116 14.9074L3.99138 10.5194C3.99706 10.5066 4 10.4928 4 10.4788V10.1387C4 10.0705 4.06687 10.0223 4.13162 10.0439L6.91026 10.9701C6.96061 10.9869 6.98907 11.0401 6.97511 11.0913L5.53024 16.3891C5.51426 16.4477 5.45018 16.4787 5.39437 16.4547L2.09315 15.0399C2.04191 15.018 2.01852 14.9583 2.04116 14.9074Z"
                fill="#000"
            ></path>
            <path
                d="M15.4753 15.9176L14.0279 11.0929C14.0123 11.0412 14.0408 10.9864 14.092 10.9693L15.5 10.5L17.405 10.0237C17.4578 10.0105 17.5114 10.042 17.5258 10.0944L18.9702 15.3907C18.986 15.4487 18.9474 15.5075 18.8879 15.516L15.5852 15.9878C15.5362 15.9948 15.4895 15.965 15.4753 15.9176Z"
                fill="#000"
            ></path>
            <path
                fillRule="evenodd"
                clip-rule="evenodd"
                d="M7.13431 8.9081L7.14739 7.15547H14.136C14.1908 7.15548 14.2433 7.135 14.2824 7.09843C14.3215 7.06187 14.3439 7.01215 14.3449 6.95998L14.3516 6.60639L15.594 7.32867L15.5982 7.33151L16.8711 8.03207L14.3251 9.43282V9.10737C14.325 9.05457 14.303 9.00394 14.2639 8.96659C14.2247 8.92924 14.1716 8.9082 14.1162 8.9081H7.13431ZM14.116 9.77809L14.3252 9.83231C14.3252 9.83231 14.4709 9.8136 14.5343 9.77809C14.5977 9.74259 17.0794 8.37697 17.0794 8.37697C17.143 8.34202 17.1958 8.29173 17.2325 8.23115C17.2692 8.17057 17.2885 8.10184 17.2885 8.03188C17.2885 7.96192 17.2692 7.89319 17.2325 7.83261C17.1958 7.77204 17.143 7.72174 17.0794 7.68679L15.8088 6.98793L14.5688 6.26697C14.506 6.2303 14.4341 6.21011 14.3604 6.20845C14.2868 6.2068 14.214 6.22373 14.1494 6.25754C14.0848 6.29134 14.0308 6.34082 13.9927 6.40096C13.9547 6.46109 13.934 6.52975 13.9327 6.59997L13.9298 6.75768H6.94012C6.88496 6.75763 6.83201 6.77841 6.79287 6.81547C6.75374 6.85253 6.73159 6.90286 6.73127 6.95544L6.71483 9.10662C6.71456 9.13292 6.71978 9.15901 6.73018 9.18337C6.74057 9.20773 6.75594 9.22989 6.77539 9.24855C6.79483 9.26721 6.81797 9.282 6.84346 9.29207C6.86895 9.30214 6.89628 9.30729 6.92388 9.30721H13.9076V9.43338C13.907 9.5034 13.926 9.57228 13.9627 9.63297C13.9993 9.69365 14.116 9.77809 14.116 9.77809ZM5.68285 5.70089C5.62742 5.70094 5.57428 5.72195 5.53508 5.75931C5.49589 5.79667 5.47385 5.84733 5.4738 5.90016V6.22579L2.92833 4.82429L4.20106 4.12373L4.20522 4.12146L5.44784 3.39899L5.45398 3.75239C5.45502 3.80461 5.47749 3.85437 5.51657 3.89099C5.55565 3.92761 5.60823 3.94817 5.66303 3.94826H12.6519L12.6651 5.70051L5.68285 5.70089ZM2.72463 4.87075L2.92833 4.82674L2.92615 4.82335H2.92774V4.82127L2.72463 4.87075ZM13.0238 6.04088C13.0433 6.02225 13.0587 6.00011 13.0691 5.97576C13.0795 5.9514 13.0847 5.92532 13.0844 5.89903L13.068 3.74729C13.0676 3.69467 13.0454 3.64433 13.0062 3.6073C12.967 3.57027 12.9139 3.54956 12.8587 3.54971H5.86871L5.86594 3.392C5.86477 3.32175 5.84412 3.25305 5.8061 3.19286C5.76807 3.13267 5.71403 3.08314 5.64944 3.04929C5.58485 3.01544 5.51202 2.99847 5.43834 3.00011C5.36465 3.00175 5.29273 3.02194 5.22987 3.05862L3.98983 3.77996L2.71928 4.47882C2.6557 4.5138 2.60291 4.56411 2.5662 4.62471C2.52949 4.6853 2.51016 4.75404 2.51016 4.82401C2.51016 4.89398 2.52949 4.96271 2.5662 5.02331C2.60291 5.0839 2.6557 5.13421 2.71928 5.16919L5.26475 6.56975C5.32828 6.60487 5.40041 6.62339 5.47386 6.62345C5.5473 6.6235 5.61946 6.60509 5.68306 6.57007C5.74665 6.53505 5.79943 6.48465 5.83606 6.42397C5.87269 6.3633 5.89189 6.29448 5.8917 6.22447V6.0983H12.8756C12.9312 6.09821 12.9845 6.07709 13.0238 6.03955V6.04088ZM5.28179 11.8207L5.2804 11.7551C5.27976 11.729 5.28453 11.703 5.29444 11.6786C5.30435 11.6542 5.3192 11.6319 5.33814 11.613C5.35708 11.5941 5.37975 11.5789 5.40484 11.5683C5.42994 11.5578 5.45697 11.552 5.4844 11.5514C5.51182 11.5508 5.53911 11.5553 5.56469 11.5648C5.59028 11.5742 5.61366 11.5884 5.6335 11.6064C5.65335 11.6245 5.66926 11.6461 5.68035 11.67C5.69143 11.694 5.69747 11.7197 5.69811 11.7459L5.69989 11.811C5.70055 11.8372 5.69578 11.8632 5.68586 11.8877C5.67595 11.9121 5.66107 11.9344 5.6421 11.9533C5.62312 11.9723 5.60041 11.9874 5.57527 11.998C5.55013 12.0085 5.52306 12.0143 5.49559 12.0148H5.49084C5.43632 12.0148 5.38398 11.9945 5.34493 11.9582C5.30589 11.922 5.28323 11.8726 5.28179 11.8207ZM15.4347 11.6975L15.4363 11.7629C15.437 11.789 15.4323 11.8151 15.4225 11.8395C15.4126 11.8639 15.3978 11.8862 15.3789 11.9052C15.36 11.9242 15.3373 11.9394 15.3122 11.95C15.2871 11.9606 15.2601 11.9664 15.2326 11.967H15.2273C15.1727 11.967 15.1203 11.9466 15.0812 11.9103C15.0422 11.874 15.0196 11.8245 15.0182 11.7725L15.0166 11.7073C15.0153 11.6545 15.036 11.6034 15.0742 11.5651C15.1124 11.5269 15.165 11.5047 15.2204 11.5034C15.2758 11.5022 15.3295 11.5219 15.3696 11.5583C15.4097 11.5948 15.4334 11.6447 15.4347 11.6975ZM18.5523 15.2717C18.5665 15.2503 18.5762 15.2263 18.5807 15.2013C18.5851 15.1763 18.5844 15.1506 18.5784 15.1259L17.4614 10.4739C17.4512 10.4311 17.4261 10.3928 17.3901 10.3653C17.3541 10.3379 17.3094 10.3229 17.2633 10.3228C17.2479 10.3229 17.2327 10.3245 17.2177 10.3277L14.6219 10.8944C14.5959 10.9 14.5713 10.9105 14.5496 10.9252C14.5279 10.94 14.5095 10.9587 14.4955 10.9803C14.4668 11.0237 14.4573 11.0761 14.4691 11.1261L14.694 12.0624L15.5857 15.777C15.5978 15.827 15.6302 15.8704 15.6758 15.8978C15.7214 15.9251 15.7765 15.9341 15.829 15.9228L18.4258 15.3561C18.4518 15.3505 18.4764 15.3401 18.4981 15.3253C18.5198 15.3105 18.5382 15.2918 18.5523 15.2702V15.2717ZM14.9643 16.5718C15.0251 16.5342 15.0747 16.4822 15.1081 16.4209C15.1415 16.3596 15.1577 16.291 15.1549 16.222C15.1607 16.1394 15.1448 16.0568 15.1086 15.9816C15.0724 15.9064 15.0171 15.841 14.9477 15.7913L11.7689 14.0011C11.5311 14.2089 10.8622 14.5581 8.7877 15.0891C8.74216 15.1007 8.69384 15.0973 8.65058 15.0794C8.03432 14.8244 7.76127 14.3696 7.86074 13.7637C7.867 13.7247 7.88528 13.6884 7.91325 13.6594C8.43756 13.117 9.22482 12.5941 10.255 12.1028C9.23671 11.6454 8.57766 11.9485 8.03769 12.1973C7.79523 12.3324 7.5247 12.4152 7.24508 12.44C7.1165 12.441 6.98989 12.4098 6.8779 12.3495L5.62162 16.0473C5.60281 16.1033 5.57324 16.1555 5.53443 16.2012C5.5382 16.2108 5.54196 16.2201 5.54573 16.2288C5.60147 16.2145 5.65832 16.2045 5.71574 16.1989C5.86916 16.1843 6.02407 16.203 6.16877 16.2538C6.31348 16.3045 6.4442 16.3859 6.55107 16.4919C6.65794 16.5978 6.73816 16.7255 6.78568 16.8653C6.83321 17.0052 6.84678 17.1534 6.82539 17.299C6.99597 17.2838 7.1678 17.3102 7.32474 17.3757C7.52267 17.4585 7.68509 17.6031 7.78525 17.7857C7.90471 17.717 8.0387 17.6744 8.17754 17.661C8.31638 17.6476 8.4566 17.6638 8.58808 17.7084C8.71956 17.7529 8.83902 17.8248 8.93783 17.9187C9.03664 18.0126 9.11233 18.1263 9.15943 18.2515C9.31615 18.1141 9.51963 18.0351 9.73251 18.0292C9.94538 18.0233 10.1534 18.0907 10.3182 18.2192C10.4681 18.3372 10.5729 18.4989 10.6167 18.6794C10.6604 18.8598 10.6405 19.049 10.5602 19.2176C10.6775 19.2409 10.7997 19.2237 10.905 19.1691C11.0102 19.1145 11.0918 19.0262 11.1352 18.9197C11.1786 18.8132 11.1809 18.6955 11.1419 18.5875C11.1028 18.4795 11.0248 18.3883 10.9218 18.3299L10.6878 18.1977L10.6898 18.1945L10.1415 17.8904C10.1173 17.8774 10.0961 17.86 10.0791 17.8392C10.0621 17.8183 10.0496 17.7945 10.0423 17.769C10.0351 17.7435 10.0332 17.7169 10.0368 17.6907C10.0405 17.6645 10.0495 17.6393 10.0635 17.6165C10.0774 17.5936 10.096 17.5737 10.1181 17.5578C10.1402 17.5418 10.1654 17.5303 10.1922 17.5237C10.2191 17.5172 10.247 17.5158 10.2744 17.5196C10.3018 17.5234 10.3282 17.5324 10.3519 17.546L11.826 18.3641C12.2468 18.5972 12.4478 18.3694 12.5146 18.2606C12.5919 18.1421 12.6172 17.9993 12.5851 17.8632C12.5529 17.727 12.4658 17.6084 12.3426 17.533L11.5993 17.1143C11.552 17.0872 11.5179 17.0434 11.5044 16.9925C11.4909 16.9416 11.499 16.8876 11.527 16.8424C11.5551 16.7971 11.6007 16.7643 11.654 16.751C11.7074 16.7377 11.764 16.7451 11.8117 16.7714L12.555 17.1902C12.5916 17.2105 12.6266 17.2334 12.6598 17.2586L13.2109 17.6363C13.2467 17.6609 13.323 17.6509 13.409 17.6105C13.5373 17.5472 13.6481 17.4559 13.7324 17.3441C13.8166 17.2323 13.872 17.103 13.8939 16.9669C13.8966 16.9055 13.8818 16.8446 13.8509 16.7906C13.8201 16.7367 13.7745 16.6917 13.7189 16.6606L13.7076 16.6534C13.7038 16.6513 13.7002 16.6489 13.6967 16.6462L13.6801 16.6366L12.3285 15.8756C12.3048 15.8622 12.2841 15.8446 12.2676 15.8236C12.251 15.8026 12.239 15.7788 12.2321 15.7533C12.2253 15.7279 12.2237 15.7015 12.2276 15.6755C12.2315 15.6496 12.2407 15.6246 12.2547 15.602C12.2687 15.5794 12.2872 15.5597 12.3092 15.5439C12.3312 15.5281 12.3562 15.5167 12.3829 15.5101C12.4096 15.5036 12.4373 15.5021 12.4645 15.5058C12.4918 15.5095 12.518 15.5183 12.5417 15.5316L13.8929 16.2926C13.9127 16.3032 13.93 16.314 13.9474 16.3251C14.3855 16.5884 14.7557 16.6783 14.9643 16.5718ZM10.1165 19.1493L9.86664 19.4398C9.80844 19.5075 9.73044 19.5573 9.64252 19.5827C9.55461 19.6082 9.46075 19.6081 9.37286 19.5826C9.28497 19.5571 9.20701 19.5073 9.14886 19.4395C9.09072 19.3717 9.05502 19.289 9.04629 19.2018C9.04097 19.1511 9.04507 19.1 9.05838 19.0507C9.09716 18.9948 9.12926 18.9349 9.15408 18.8722L9.3992 18.5875C9.47885 18.5016 9.59037 18.4485 9.71029 18.4393C9.83021 18.4302 9.94917 18.4658 10.0421 18.5386C10.1351 18.6114 10.1948 18.7157 10.2086 18.8296C10.2225 18.9435 10.1895 19.0581 10.1165 19.1493ZM8.04958 19.3682C7.94648 19.3775 7.84281 19.3575 7.7516 19.3107C7.66039 19.264 7.58573 19.1926 7.53701 19.1055C7.48829 19.0183 7.46769 18.9195 7.4778 18.8212C7.48791 18.723 7.52828 18.6298 7.59383 18.5534L7.8653 18.2366C7.94166 18.1482 8.04755 18.0874 8.16527 18.0644C8.28299 18.0414 8.40543 18.0576 8.51211 18.1103C8.6188 18.163 8.70329 18.249 8.75146 18.354C8.79964 18.4589 8.80858 18.5764 8.7768 18.6869C8.73574 18.7438 8.70244 18.8055 8.67772 18.8705L8.67614 18.8718L8.40348 19.1886C8.35971 19.2393 8.30586 19.2813 8.24503 19.3121C8.1842 19.3429 8.11817 19.362 8.04958 19.3682ZM7.05882 18.9863C6.96214 19.0992 6.82394 19.1727 6.67237 19.1919C6.52081 19.211 6.36728 19.1744 6.24307 19.0894C6.11885 19.0044 6.0333 18.8775 6.00384 18.7345C5.97438 18.5915 6.00323 18.4431 6.0845 18.3197C6.16631 18.2671 6.23972 18.2034 6.30247 18.1308L6.60386 17.7812C6.60901 17.775 6.61436 17.7687 6.61912 17.7623C6.70101 17.7204 6.79171 17.6966 6.88455 17.6926C6.97738 17.6886 7.06998 17.7045 7.15552 17.7391C7.22976 17.7708 7.29578 17.8177 7.34889 17.8765C7.40201 17.9352 7.44091 18.0044 7.46285 18.0791L7.27084 18.3003C7.19203 18.3913 7.13297 18.4963 7.09708 18.6093C7.0612 18.7223 7.0492 18.8409 7.06179 18.9583C7.06179 18.9657 7.06357 18.973 7.06456 18.98L7.05882 18.9863ZM5.13258 17.9571C5.07156 17.9093 5.02101 17.8505 4.98383 17.7841C4.94664 17.7177 4.92354 17.645 4.91585 17.5701C4.90816 17.4951 4.91602 17.4195 4.939 17.3475C4.96197 17.2755 4.99961 17.2085 5.04975 17.1503L5.35074 16.8003C5.40085 16.7422 5.46255 16.6941 5.53228 16.6588C5.602 16.6236 5.67836 16.6018 5.75696 16.5948C5.7771 16.5928 5.79734 16.5918 5.81759 16.5918C5.95608 16.5915 6.09033 16.6373 6.19725 16.7212C6.32037 16.8178 6.39828 16.957 6.41388 17.1082C6.42948 17.2595 6.38151 17.4105 6.28048 17.5281L5.97849 17.8781C5.87708 17.9953 5.73107 18.0694 5.57245 18.0842C5.41382 18.099 5.2559 18.0533 5.13258 17.9571ZM2.48209 15.1705L5.10741 15.9806C5.1308 15.9875 5.1561 15.9854 5.17793 15.9749C5.19975 15.9643 5.2164 15.946 5.22432 15.9239L6.80122 11.2814C6.80852 11.2591 6.80639 11.235 6.79528 11.2142C6.78418 11.1933 6.76498 11.1775 6.74177 11.17L4.11645 10.3595C4.10483 10.3559 4.09259 10.3547 4.08044 10.3557C4.0683 10.3567 4.05649 10.3601 4.04571 10.3655C4.03479 10.3706 4.02506 10.3778 4.0171 10.3865C4.00913 10.3953 4.00309 10.4055 3.99934 10.4165L2.42225 15.0588C2.41487 15.0812 2.41708 15.1055 2.42839 15.1263C2.43959 15.1471 2.45885 15.163 2.48209 15.1705ZM12.8336 12.1861C12.333 11.9784 11.8601 11.7835 10.8075 12.2912C10.8056 12.2922 10.8036 12.2931 10.8015 12.2938C9.66849 12.7985 8.81544 13.3327 8.26517 13.8848C8.23644 14.0514 8.26922 14.2224 8.35792 14.3686C8.44662 14.5148 8.58576 14.6272 8.75164 14.6866C11.2801 14.0342 11.5087 13.6946 11.5258 13.6577C11.538 13.6324 11.5557 13.6098 11.5776 13.5915C11.5996 13.5731 11.6254 13.5593 11.6533 13.551C11.6812 13.5427 11.7106 13.5401 11.7396 13.5433C11.7687 13.5465 11.7967 13.5555 11.8218 13.5697L15.0636 15.3954L14.3368 12.3626C13.8301 12.4858 13.2934 12.4234 12.8336 12.1861ZM17.8688 10.3852C17.832 10.2321 17.7329 10.0993 17.5934 10.0158C17.4539 9.93233 17.2854 9.90506 17.1248 9.93996L14.529 10.5066C14.3682 10.5416 14.2287 10.6361 14.141 10.7691C14.0532 10.9022 14.0245 11.063 14.0611 11.2162L14.2434 11.9742C13.7027 12.1108 13.3745 11.9742 13 11.8203C12.4749 11.6027 11.8815 11.357 10.7213 11.8866C9.36294 11.1448 8.49344 11.5447 7.85499 11.8388C7.40915 12.0439 7.21298 12.1112 7.01106 11.9553L7.19832 11.4042C7.23957 11.2813 7.22816 11.1478 7.16657 11.0329C7.10498 10.918 6.99822 10.831 6.86958 10.7909L4.24505 9.98057C4.11616 9.94109 3.97611 9.95187 3.85553 10.0106C3.73496 10.0692 3.64368 10.1711 3.60165 10.2937L2.02475 14.9361C1.98312 15.0589 1.99433 15.1925 2.05593 15.3074C2.11753 15.4224 2.22448 15.5093 2.35329 15.5492L4.97842 16.3597C5.0292 16.3753 5.08221 16.3832 5.13555 16.3833C5.14387 16.3833 5.1522 16.3833 5.16072 16.3833C5.16468 16.3925 5.16884 16.4012 5.1736 16.4101C5.1201 16.4514 5.07116 16.4978 5.02756 16.5486L4.72637 16.8982C4.60372 17.0403 4.52597 17.2127 4.50216 17.3953C4.47835 17.5779 4.50947 17.7632 4.59189 17.9296C4.6743 18.096 4.80463 18.2367 4.96767 18.3352C5.13072 18.4337 5.31978 18.4861 5.51283 18.4861C5.53721 18.4861 5.56158 18.4861 5.58555 18.4837C5.55629 18.6759 5.5882 18.8722 5.67715 19.047C5.7661 19.2218 5.90801 19.3672 6.08455 19.4644C6.26108 19.5615 6.46412 19.606 6.66744 19.592C6.87075 19.578 7.065 19.5062 7.22507 19.3859C7.30602 19.4959 7.41175 19.5872 7.53452 19.6531C7.65728 19.7191 7.79397 19.758 7.93457 19.767C8.07516 19.7761 8.2161 19.7551 8.34706 19.7055C8.47801 19.6559 8.59567 19.579 8.6914 19.4804C8.75802 19.6341 8.87096 19.7654 9.01592 19.8579C9.16088 19.9504 9.33136 19.9999 9.5058 20C9.63631 20.0002 9.76523 19.9728 9.88327 19.9197C10.0013 19.8667 10.1055 19.7893 10.1884 19.6933L10.3048 19.5582C10.4497 19.6166 10.6079 19.6388 10.7644 19.6226C10.9209 19.6064 11.0704 19.5524 11.1988 19.4656C11.3272 19.3789 11.4302 19.2623 11.4981 19.1269C11.566 18.9916 11.5964 18.8419 11.5866 18.6922L11.6155 18.7084C11.78 18.8053 11.9686 18.8587 12.1618 18.8631C12.3073 18.8622 12.4499 18.8247 12.5752 18.7542C12.7005 18.6838 12.804 18.583 12.8752 18.4621C12.9623 18.3171 13.0094 18.1534 13.0119 17.9863C13.0885 18.0272 13.175 18.0483 13.2628 18.0477C13.3778 18.0451 13.4907 18.0176 13.5929 17.9673C13.7893 17.8729 13.9578 17.7334 14.0834 17.5614C14.209 17.3893 14.2875 17.1901 14.312 16.9819C14.312 16.9669 14.312 16.9524 14.312 16.9378C14.4466 16.9923 14.5918 17.0192 14.7381 17.0166C14.8843 17.0141 15.0284 16.9822 15.1609 16.9231C15.2793 16.859 15.3788 16.7675 15.4501 16.6569C15.5214 16.5463 15.5622 16.4204 15.5687 16.2907C15.6373 16.3153 15.71 16.3281 15.7833 16.3285C15.8299 16.3285 15.8765 16.3235 15.922 16.3136L18.5178 15.7469C18.6782 15.7116 18.8173 15.6171 18.9048 15.4842C18.9923 15.3513 19.021 15.1907 18.9846 15.0377L17.8688 10.3852Z"
                fill="#000"
            ></path>
        </svg>],
        route: ['/trade', '/trade', '/trade'],
        subTitle: ['Spot Trade', 'Copy Trade', 'Margin Trade']
    },


]

const Header = () => {
    const [anchorElUser, setAnchorElUser] = useState(null);
    const { isLightMode, handleDarkmode } = useContext(ThemeContext);

    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const [open, setOpen] = useState(false);

    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };
    const [anchorEl, setAnchorEl] = useState(null);
    const open2 = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setUp(true);
    };
    const handleClose = () => {
        setAnchorEl(null);
        setUp(false);
    };

    const [up, setUp] = useState(false);

    const theme = useTheme();
    const lg = useMediaQuery(theme.breakpoints.up("lg"));

    const navigate = useNavigate();

    const [open3, setOpen3] = useState(Array(headers.length).fill(false));

    const handleClick2 = (ind) => {
        setOpen3(prevState => {
            const newState = [...prevState];
            newState[ind] = !newState[ind];
            return newState;
        });
    };

    const darkTheme = window.localStorage.getItem('theme')
    const depo = (
        <>
            {/* <div className="reg-h-btn display-3">
                <Button variant="contained" onClick={() => navigate("/deposit")}>
                    Deposit
                </Button>
            </div>
            <div className="login-h-btn display-1">
                <Button variant="contained" onClick={() => navigate("/wallet")}>
                    Wallet
                </Button>
            </div>
            <div className="login-h-btn display-1">
                <Button variant="contained" onClick={() => navigate("/trade")}>
                    Order
                </Button>
            </div> */}

            <div className="login-h-btn display-1">
                <Button variant="contained" onClick={() => navigate("/login")}>
                    Login
                </Button>
            </div>
            <div className="reg-h-btn display-3">
                <Button variant="contained" onClick={() => navigate("/deposit")}>
                    Register
                </Button>
            </div>

            <div className="display-1 ">
                {lg && <div className="hoz-des"></div>}
                {/* <Deposit />
                <Help /> */}
            </div>
        </>
    );
    const profileDrop = (
        <>
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                {/* <Avatar
          className="avatar-border"
          alt="Remy Sharp"
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQE4gyGOCj-ir1zYqWIgZUBJWSBZsXJtevdpjJlWpzVAg&s"
        /> */}
                <div className="profile-img">
                    <Avatar src="/broken-image.jpg" />
                </div>
            </IconButton>
            <Menu
                sx={{ mt: "4px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
                className="mui-list profile-list"
            >
                {settings.map((setting) => (
                    <MenuItem key={setting} onClick={handleCloseUserMenu}>
                        <Typography
                            className="profile-set display-2"
                            textAlign="center"
                            onClick={() => navigate(setting.url)}
                        >
                            {setting.icon}
                            {setting.name}
                        </Typography>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
    const darkMode = (
        <div className="text-center">
            <Darkmode />
        </div>
    );

    const DrawerList = (
        <Box sx={{ width: 250 }} role="presentation" >
            {/* <List>
        {pages.map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton onClick={() => navigate(text.url)}>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text.name} />
            </ListItemButton>
          </ListItem>
        ))}
      </List> */}
            <List
                sx={{ width: '100%', maxWidth: 360, bgcolor: 'var(--clr-bcg)' }}
                component="nav"
                aria-labelledby="nested-list-subheader"


            >
                {headers.map((obj, ind) => {
                    return (
                        <>
                            <ListItemButton onClick={(() => { handleClick2(ind) })}>

                                <ListItemText primary={obj.title === '' ?
                                    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_15_11881)">
                                            <g clip-path="url(#clip1_15_11881)">
                                                <g clip-path="url(#clip2_15_11881)">
                                                    <path fillRule="evenodd" clip-rule="evenodd" d="M9.38086 11.738V15.5156H5.70261V11.738H9.38086ZM15 11.738V15.5156H11.3217V11.738H15ZM3.67826 11.738V15.5156H0V11.738H3.67826ZM3.67826 6.12679V9.90446H0V6.12679H3.67826ZM9.38086 6.12679V9.90446H5.70261V6.12679H9.38086ZM15 6.12679V9.90446H11.3217V6.12679H15ZM3.67826 0.515625V4.29329H0V0.515625H3.67826ZM9.38086 0.515625V4.29329H5.70261V0.515625H9.38086ZM15 0.515625V4.29329H11.3217V0.515625H15Z"
                                                        fill={isLightMode ? "#000" : "white"} />
                                                </g>
                                            </g>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_15_11881">
                                                <rect width="15" height="15" fill={isLightMode ? "#000" : "white"} transform="translate(0 0.515625)" />
                                            </clipPath>
                                            <clipPath id="clip1_15_11881">
                                                <rect width="15" height="15" fill={isLightMode ? "#000" : "white"} transform="translate(0 0.515625)" />
                                            </clipPath>
                                            <clipPath id="clip2_15_11881">
                                                <rect width="15" height="15" fill={isLightMode ? "#000" : "white"} transform="translate(0 0.515625)" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    : obj.title} />
                                {open3[ind] ? <ExpandLess /> : <ExpandMore />}
                            </ListItemButton>


                            {obj.title == '' ?
                                <Collapse in={open3[ind]} timeout="auto" unmountOnExit>

                                    {obj.sub?.map((row1, index) => {
                                        return (
                                            <List component="div" disablePadding>
                                                <ListItemButton sx={{ pl: 4 }}>
                                                    <ListItemIcon>
                                                        <div className="head-icon">
                                                            {obj.svg2[index]}
                                                        </div>

                                                    </ListItemIcon>
                                                    <ListItemText primary={row1} />
                                                </ListItemButton>
                                            </List>
                                        )
                                    })}



                                </Collapse> :



                                <Collapse in={open3[ind]} timeout="auto" unmountOnExit>

                                    {obj.subTitle?.map((row1, index) => {
                                        return (
                                            <List component="div" disablePadding>
                                                <ListItemButton sx={{ pl: 4 }}>
                                                    <ListItemIcon>
                                                        <div className="head-icon">
                                                            {obj.svg[index]}
                                                        </div>

                                                    </ListItemIcon>
                                                    <ListItemText primary={row1} />
                                                </ListItemButton>
                                            </List>
                                        )
                                    })}



                                </Collapse>
                            }
                        </>

                    )
                })}


            </List>
            <List>{depo}</List>
            <List>{darkMode}</List>
            <List className="text-center">{profileDrop}</List>
        </Box>
    );


    return (
        <div className="header">
            <AppBar position="static">
                <Container maxWidth="100%">
                    <Toolbar disableGutters className="menu-bar">
                        <div className="logo head">
                            <Link to="/">
                                {/* <img src={isLightMode ? darkLogo : lightlogo} /> */}
                                <img src={logo} alt="apx" />
                            </Link>
                        </div>

                        <Box sx={{ flexGrow: 1, display: { xs: "flex", lg: "none" } }} className='justi-end'>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                            // onClick={handleOpenNavMenu}
                            // color="inherit"
                            >
                                <MenuIcon onClick={toggleDrawer(true)} sx={{ fill: 'var(--clr-font)' }} />
                            </IconButton>
                        </Box>
                        {lg && <>
                            <Box
                                sx={{ flexGrow: 1, display: { xs: "none", md: "flex" }, gap: 2 }}
                            >


                                <div className="menu-items">
                                    <List>
                                        <ListItem>
                                            <div className="whole-list">
                                                {headers.map((row, ind) => {
                                                    return (
                                                        <div className={row.title !== 'Markets' && "drop-down-menu-exch"}>
                                                            <Link>
                                                                {row.title === '' ?
                                                                    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <g clip-path="url(#clip0_15_11881)">
                                                                            <g clip-path="url(#clip1_15_11881)">
                                                                                <g clip-path="url(#clip2_15_11881)">
                                                                                    <path fillRule="evenodd" clip-rule="evenodd" d="M9.38086 11.738V15.5156H5.70261V11.738H9.38086ZM15 11.738V15.5156H11.3217V11.738H15ZM3.67826 11.738V15.5156H0V11.738H3.67826ZM3.67826 6.12679V9.90446H0V6.12679H3.67826ZM9.38086 6.12679V9.90446H5.70261V6.12679H9.38086ZM15 6.12679V9.90446H11.3217V6.12679H15ZM3.67826 0.515625V4.29329H0V0.515625H3.67826ZM9.38086 0.515625V4.29329H5.70261V0.515625H9.38086ZM15 0.515625V4.29329H11.3217V0.515625H15Z"
                                                                                        fill={isLightMode ? "#000" : "white"} />
                                                                                </g>
                                                                            </g>
                                                                        </g>
                                                                        <defs>
                                                                            <clipPath id="clip0_15_11881">
                                                                                <rect width="15" height="15" fill={isLightMode ? "#000" : "white"} transform="translate(0 0.515625)" />
                                                                            </clipPath>
                                                                            <clipPath id="clip1_15_11881">
                                                                                <rect width="15" height="15" fill={isLightMode ? "#000" : "white"} transform="translate(0 0.515625)" />
                                                                            </clipPath>
                                                                            <clipPath id="clip2_15_11881">
                                                                                <rect width="15" height="15" fill={isLightMode ? "#000" : "white"} transform="translate(0 0.515625)" />
                                                                            </clipPath>
                                                                        </defs>
                                                                    </svg>

                                                                    : row.title === 'Markets' ? <Link to='/market'>Market</Link> : row.title}
                                                                {!['Copy Trading', 'Help Center', 'Markets'].includes(row.title) && <ArrowDropDownIcon />}
                                                            </Link>

                                                            {(row.title === '') ? <>

                                                                <List className="mega-ul">
                                                                    <div className="mega-box drop-menu">
                                                                        <div className="content">
                                                                            <span>{row.span[0]}</span>

                                                                            {row.sub.slice(0, 5).map((row2, index2) => {
                                                                                return (
                                                                                    <ListItem className="cursor">
                                                                                        <div className="head-icon">
                                                                                            {row.svg2[index2]}
                                                                                            <Link to="/">
                                                                                                {row2}
                                                                                            </Link>

                                                                                        </div>
                                                                                    </ListItem>
                                                                                )
                                                                            })}

                                                                        </div>
                                                                        <div className="content">
                                                                            <span>{row.span[1]}</span>
                                                                            {row.sub.slice(5, 10).map((row2, index2) => {
                                                                                return (
                                                                                    <ListItem className="cursor">
                                                                                        <div className="head-icon">
                                                                                            {row.svg2[index2]}
                                                                                            <Link to="/">
                                                                                                {row2}
                                                                                            </Link>

                                                                                        </div>
                                                                                    </ListItem>
                                                                                )
                                                                            })}
                                                                        </div>
                                                                        <div className="content">
                                                                            <span>{row.span[2]}</span>
                                                                            {row.sub.slice(10, 15).map((row2, index2) => {
                                                                                return (
                                                                                    <ListItem className="cursor">
                                                                                        <div className="head-icon">
                                                                                            {row.svg2[index2]}
                                                                                            <Link to="/">
                                                                                                {row2}
                                                                                            </Link>

                                                                                        </div>
                                                                                    </ListItem>
                                                                                )
                                                                            })}
                                                                        </div>
                                                                    </div>
                                                                </List>
                                                            </> : <List className="drop-menu">
                                                                {row.svg?.map((obj, index) => {
                                                                    return (
                                                                        <ListItem className="cursor">
                                                                            <div className="head-icon">
                                                                                {obj}
                                                                                <Link to={row.route[index]}>{row.subTitle[index]}</Link>
                                                                            </div>
                                                                        </ListItem>
                                                                    )
                                                                })}



                                                            </List>}

                                                        </div>
                                                    )
                                                })}

                                            </div>
                                        </ListItem>
                                    </List>

                                </div>
                            </Box>
                        </>}


                        {lg && <Box sx={{ flexGrow: 0 }} className="display-1">

                            {lg ? depo : null}

                            {lg ? darkMode : null}
                            {lg ? profileDrop : null}

                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={open2}
                                onClose={handleClose}
                                MenuListProps={{
                                    "aria-labelledby": "basic-button",
                                }}
                                className="mui-list profile-list"
                            >
                                {settings2.map((setting) => (
                                    <MenuItem key={setting} onClick={handleClose}>
                                        <Typography
                                            textAlign="center"
                                            onClick={() => navigate(setting.url)}
                                        >
                                            {setting.name}
                                        </Typography>
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box>}
                    </Toolbar>
                </Container>
            </AppBar>
            <div>
                {/* <Button onClick={toggleDrawer(true)}>Open drawer</Button> */}
                <Drawer open={open} onClose={toggleDrawer(false)} className="drawer menu-items">

                    {DrawerList}


                </Drawer>
            </div>


        </div>
    );
};

export default Header;
